import { vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "value", "name", "disabled"]
const _hoisted_2 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("input", {
      id: _ctx.getId,
      type: "radio",
      value: _ctx.label,
      name: _ctx.name,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.radioButtonValue) = $event)),
      class: "btn-check",
      autocomplete: "off",
      disabled: _ctx.disableRadio
    }, null, 8, _hoisted_1), [
      [_vModelRadio, _ctx.radioButtonValue]
    ]),
    _createElementVNode("label", {
      class: "btn btn-outline-secondary form-control",
      for: _ctx.getId
    }, _toDisplayString(_ctx.label), 9, _hoisted_2)
  ], 64))
}